interface LoadingSpinnerProps {
    message?: string;
    size?: 'sm' | 'md' | 'lg';
}

function LoadingSpinner({ message = 'Loading...', size = 'md' }: LoadingSpinnerProps) {
    const sizeClasses = {
        sm: 'w-8 h-8',
        md: 'w-12 h-12',
        lg: 'w-16 h-16'
    };

    return (
        <div className="flex items-center justify-center h-full">
            <div className="text-center">
                <div className={`${sizeClasses[size]} mx-auto mb-4`}>
                    <div className="animate-spin rounded-full border-4 border-zinc-600 border-t-logwatch-blue"></div>
                </div>
                <p className="text-zinc-400">{message}</p>
            </div>
        </div>
    );
}

export default LoadingSpinner;
